module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_33.75deg.b4a98ff7.png";